import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getBusinessUnitGroups, BusinessUnitGroup } from '../../api/business-unit-groups';
import { getBusinessUnitsLocal } from '../../api/business-units';
import { BusinessUnit } from '../BusinessUnit/businessUnitSlice';
import { getProjectStatuses, ProjectStatus } from '../../api/project-statuses';

// Async thunks
export const getBusinessUnitGroupsAsync = createAsyncThunk(
  'plugAndPlayMasterData/getBusinessUnitGroups',
  getBusinessUnitGroups
);

export const getBusinessUnitsAsync = createAsyncThunk(
  'plugAndPlayMasterData/getBusinessUnits',
  getBusinessUnitsLocal
);

export const getProjectStatusesAsync = createAsyncThunk(
  'plugAndPlayMasterData/getProjectStatuses',
  getProjectStatuses
);

interface MasterDataState {
  businessUnitGroups: {
    data: BusinessUnitGroup[];
    loading: boolean;
    error: string | null;
  };
  businessUnits: {
    data: BusinessUnit[];
    loading: boolean;
    error: string | null;
  };
  projectStatuses: {
    data: ProjectStatus[];
    loading: boolean;
    error: string | null;
  };
}

const initialState: MasterDataState = {
  businessUnitGroups: {
    data: [],
    loading: false,
    error: null
  },
  businessUnits: {
    data: [],
    loading: false,
    error: null
  },
  projectStatuses: {
    data: [],
    loading: false,
    error: null
  }
};

const masterDataSlice = createSlice({
  name: 'plugAndPlayMasterData',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Business Unit Groups
    builder
      .addCase(getBusinessUnitGroupsAsync.pending, (state) => {
        state.businessUnitGroups.loading = true;
        state.businessUnitGroups.error = null;
      })
      .addCase(getBusinessUnitGroupsAsync.fulfilled, (state, action) => {
        state.businessUnitGroups.loading = false;
        state.businessUnitGroups.data = action.payload.data;
      })
      .addCase(getBusinessUnitGroupsAsync.rejected, (state, action) => {
        state.businessUnitGroups.loading = false;
        state.businessUnitGroups.error = action.error.message || 'Failed to fetch business unit groups';
      });

    // Business Units
    builder
      .addCase(getBusinessUnitsAsync.pending, (state) => {
        state.businessUnits.loading = true;
        state.businessUnits.error = null;
      })
      .addCase(getBusinessUnitsAsync.fulfilled, (state, action) => {
        state.businessUnits.loading = false;
        state.businessUnits.data = action.payload.data;
      })
      .addCase(getBusinessUnitsAsync.rejected, (state, action) => {
        state.businessUnits.loading = false;
        state.businessUnits.error = action.error.message || 'Failed to fetch business units';
      });

    // Project Statuses
    builder
      .addCase(getProjectStatusesAsync.pending, (state) => {
        state.projectStatuses.loading = true;
        state.projectStatuses.error = null;
      })
      .addCase(getProjectStatusesAsync.fulfilled, (state, action) => {
        state.projectStatuses.loading = false;
        state.projectStatuses.data = action.payload.data;
      })
      .addCase(getProjectStatusesAsync.rejected, (state, action) => {
        state.projectStatuses.loading = false;
        state.projectStatuses.error = action.error.message || 'Failed to fetch project statuses';
      });
  }
});

export default masterDataSlice;